<template>
  <gj-select
      v-bind="$attrs"
      v-on="$listeners"
      :options="countryOptions"
      :placeholder="placeholder"
      :clearable="clearable"
      :type="multiple ? 'multi-check' : 'default'"
      :width="width"
  ></gj-select>
</template>

<script>
  import {mapGetters} from "vuex";
  export default {
    name: "gj-country-select",
    props: {
      includeCN: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '国家'
      },
      clearable: {
        default: true
      },
      width: {
        type: String,
        default: '135px'
      }
    },
    computed: {
      ...mapGetters(['countries']),
      countryOptions() {
        const countries = this._.cloneDeep(this.countries);
        if (this.includeCN) {
          return [{id: 'CN', text: 'CN'}].concat(countries);
        }
        return countries;
      }
    },
  }
</script>

<style scoped>

</style>
